import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Users, Target, Heart, Award } from 'lucide-react';
import Layout from '../components/layout/Layout';
import NewsletterForm from '../components/common/NewsletterForm';
import { Badge } from '../components/ui/badge';

export const AboutPage = () => {
  return (
    <Layout>
      {/* Header */}
      <section className="py-8 md:py-12 border-b border-[#D6D2C4]" data-testid="about-header">
        <div className="container mx-auto px-4">
          <div className="flex items-center gap-2 text-sm text-[#5C5C5C] font-['Inter'] mb-4">
            <Link to="/" className="hover:text-[#0F5A34]">Início</Link>
            <ChevronRight size={14} />
            <span className="text-[#1A1A1A]">Sobre Nós</span>
          </div>
          
          <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4">
            Sobre o Portugal à Vista
          </h1>
          
          <p className="text-[#5C5C5C] font-['Inter'] text-base max-w-2xl">
            Conectando você com Portugal através de informação de qualidade.
          </p>
        </div>
      </section>

      {/* Hero Image */}
      <section className="relative h-64 md:h-96">
        <img
          src="https://images.unsplash.com/photo-1644871328663-e56feeb8615c?w=1200"
          alt="Lisboa, Portugal"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8">
          <div className="container mx-auto">
            <Badge className="bg-[#DFAF3A] text-[#1A1A1A] font-['Montserrat'] text-xs uppercase tracking-wider mb-2">
              Nossa Missão
            </Badge>
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-white">
              Ajudando você a realizar o sonho de viver em Portugal
            </h2>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16" data-testid="about-content">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="prose prose-lg">
              <p className="text-[#1A1A1A] font-['Inter'] text-lg leading-relaxed mb-6">
                O <strong>Portugal à Vista</strong> nasceu da necessidade de criar um espaço de informação confiável e atualizado para todos os lusófonos que sonham em conhecer ou viver em Portugal.
              </p>
              
              <p className="text-[#5C5C5C] font-['Inter'] text-base leading-relaxed mb-6">
                Somos uma equipe apaixonada por Portugal e comprometida em fornecer conteúdo de qualidade sobre imigração, vistos, custo de vida, mercado de trabalho e muito mais. Nossa missão é ser o seu guia confiável em todas as etapas da sua jornada.
              </p>

              <p className="text-[#5C5C5C] font-['Inter'] text-base leading-relaxed mb-8">
                Com anos de experiência no tema de imigração e uma rede de parceiros especializados, oferecemos não apenas informação, mas também recursos práticos como guias, e-books e recomendações de serviços de confiança.
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
              <div className="bg-white p-6 rounded-sm border border-[#D6D2C4]">
                <div className="w-12 h-12 rounded-full bg-[#0F5A34]/10 flex items-center justify-center mb-4">
                  <Target size={24} className="text-[#0F5A34]" />
                </div>
                <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#1A1A1A] mb-2">
                  Nossa Missão
                </h3>
                <p className="text-[#5C5C5C] font-['Inter'] text-sm">
                  Democratizar o acesso à informação de qualidade sobre Portugal, ajudando pessoas a tomarem decisões informadas sobre imigração.
                </p>
              </div>

              <div className="bg-white p-6 rounded-sm border border-[#D6D2C4]">
                <div className="w-12 h-12 rounded-full bg-[#0F5A34]/10 flex items-center justify-center mb-4">
                  <Users size={24} className="text-[#0F5A34]" />
                </div>
                <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#1A1A1A] mb-2">
                  Nossa Comunidade
                </h3>
                <p className="text-[#5C5C5C] font-['Inter'] text-sm">
                  Milhares de pessoas nos acompanham diariamente em busca de informações atualizadas sobre Portugal.
                </p>
              </div>

              <div className="bg-white p-6 rounded-sm border border-[#D6D2C4]">
                <div className="w-12 h-12 rounded-full bg-[#0F5A34]/10 flex items-center justify-center mb-4">
                  <Heart size={24} className="text-[#0F5A34]" />
                </div>
                <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#1A1A1A] mb-2">
                  Nossos Valores
                </h3>
                <p className="text-[#5C5C5C] font-['Inter'] text-sm">
                  Transparência, confiabilidade e compromisso com a verdade são os pilares do nosso trabalho.
                </p>
              </div>

              <div className="bg-white p-6 rounded-sm border border-[#D6D2C4]">
                <div className="w-12 h-12 rounded-full bg-[#0F5A34]/10 flex items-center justify-center mb-4">
                  <Award size={24} className="text-[#0F5A34]" />
                </div>
                <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#1A1A1A] mb-2">
                  Nossa Expertise
                </h3>
                <p className="text-[#5C5C5C] font-['Inter'] text-sm">
                  Anos de experiência em imigração portuguesa e uma equipe dedicada a pesquisar e verificar cada informação.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <NewsletterForm />
    </Layout>
  );
};

export default AboutPage;
